import { Button } from '../Button';

export interface MyPacksButtonProps {
  onClick?: () => void;
  label?: string;
  disabled?: boolean;
}

/**
 * Classic-template MyPacks button. Renders as a single DS
 * `Button variant="glass-frosted"` on every breakpoint, sized `md`
 * under 600px and `lg` above — matching the modern template's
 * MyPacksPill so the surface inherits all `--co-Button-glass-frosted*`
 * theming knobs from Design Constructor. Pinned to the 3rd grid
 * column (right edge) by the outer wrapper.
 *
 * Replaces the prior mobile-only D-shape pill (Figma 31:14667), which
 * read too bright on dark Pack pages and didn't pick up the partner's
 * glass-frosted theme.
 */
export function MyPacksButton({ onClick, label = 'My Packs', disabled = false }: MyPacksButtonProps) {
  return (
    <span className="inline-block col-start-3 row-start-1 justify-self-end">
      <span className="@[600px]:hidden">
        <Button
          variant="glass-frosted"
          size="md"
          onClick={onClick}
          disabled={disabled}
          aria-label={label}
        >
          {label}
        </Button>
      </span>
      <span className="hidden @[600px]:inline-flex">
        <Button
          variant="glass-frosted"
          size="lg"
          onClick={onClick}
          disabled={disabled}
          aria-label={label}
        >
          {label}
        </Button>
      </span>
    </span>
  );
}
